/**
 * Внешний store времени плеера: обновления не ре-рендерят карточку встречи,
 * только подписчиков (расшифровка).
 */
export type PlaybackTimeStore = {
  subscribe: (listener: () => void) => () => void;
  getSnapshot: () => number;
  setTimeMs: (nextMs: number) => void;
};

export function createPlaybackTimeStore(): PlaybackTimeStore {
  let timeMs = 0;
  let lastEmitAt = 0;
  const listeners = new Set<() => void>();

  return {
    subscribe(listener) {
      listeners.add(listener);
      return () => {
        listeners.delete(listener);
      };
    },
    getSnapshot() {
      return timeMs;
    },
    setTimeMs(nextMs) {
      const now = performance.now();
      // Не чаще ~4 раз/с и без микродрожания.
      if (now - lastEmitAt < 250 && Math.abs(nextMs - timeMs) < 500) {
        return;
      }
      lastEmitAt = now;
      if (nextMs === timeMs) {
        return;
      }
      timeMs = nextMs;
      for (const listener of listeners) {
        listener();
      }
    },
  };
}
